/**
 *
 * ModalCreateUser
 *
 */

import React from "react"
import { Modal, Input, Select } from "antd"
import { Form } from "@ant-design/compatible"
import { createUser, updateUser, listGenders } from "services/control-panel"
import { map, omit, isEqual, pick, get } from "lodash"
import validateEmail from "utils/validateEmail"
import "@ant-design/compatible/assets/index.css"
import "./index.less"
import { LOCAL_USER_ID } from "../../utils/storage"
import { buttonAction_btns } from "../Snowplow/config2"

const FormItem = Form.Item
const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
class ModalCreateUser extends React.Component {
  state = {
    id: "",
    first_name: "",
    last_name: "",
    second_last_name: "",
    id_gender: undefined,
    company_id: this.props.company_id,
    email: "",
    id_role: undefined,
    genders: [],
    loadingButtonSave: false,
  }

  componentDidUpdate = (prevProps) => {
    if (!isEqual(prevProps.userSelected, this.props.userSelected)) {
      if (!this.props.userSelected.first_name) return this.resetFields()

      this.setState({
        ...pick(this.props.userSelected, [
          "first_name",
          "last_name",
          "second_last_name",
          "id_gender",
          "email",
          "id_role",
          "id",
        ]),
      })
    }
  }

  componentDidMount = async () => {
    try {
      const {
        data: { data: genders },
      } = await listGenders()
      this.setState({ genders })
    } catch (error) {}
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  validateSave = () => {
    const {
      first_name,
      last_name,
      second_last_name,
      id_gender,
      email,
      id_role,
    } = this.state
    if (this.state.id) {
      return isEqual(
        {
          first_name,
          last_name,
          id_gender: id_gender.toString(),
          email,
          id_role,
          second_last_name,
        },
        pick(this.props.userSelected, [
          "first_name",
          "last_name",
          "id_gender",
          "email",
          "id_role",
          "second_last_name",
        ])
      )
    }

    return !first_name || !last_name || !id_gender || !email || !id_role
  }

  sendCreateServer = async () => {
    try {
      this.setState({ loadingButtonSave: true })
      const response = await createUser(
        omit(this.state, ["genders", "loadingButtonSave", "id"])
      )
      this.props.getUsers()
      returnMessage(response)
      this.props.setStateFrom("modalCreateUser", false)
      this.resetFields()
      this.props.setStateFrom("userSelected", {})
    } catch (e) {
      const {
        response: {
          data: {
            data: { error },
          },
        },
      } = e
      this.setState({ loadingButtonSave: false })
      returnMessage(e)
    }
  }

  sendUpdateServer = async () => {
    try {
      this.setState({ loadingButtonSave: true })
      const response = await updateUser(
        omit(this.state, ["genders", "loadingButtonSave", "id"]),
        this.state.id
      )
      this.props.getUsers()
      returnMessage(response)

      this.props.setStateFrom("modalCreateUser", false)

      this.resetFields()
      this.props.updateInfoUserWatcher()
      this.props.setStateFrom("userSelected", {})
    } catch (e) {
      const {
        response: {
          data: {
            data: { error },
          },
        },
      } = e
      this.setState({ loadingButtonSave: false })
      returnMessage(e)
    }
  }

  resetFields = () => {
    this.setState(
      {
        loadingButtonSave: false,
        id: "",
        first_name: "",
        last_name: "",
        second_last_name: "",
        id_gender: undefined,
        email: "",
        id_role: undefined,
      },
      () => {
        this.props.form.resetFields()
      }
    )
  }

  render() {
    const {
      form: { getFieldDecorator, resetFields, validateFieldsAndScroll },
    } = this.props
    return (
      <Modal
        title={
          this.props.title ||
          (this.state.id ? "Editar usuario" : "Crear usuario")
        }
        width={530}
        visible={this.props.visible}
        okText={this.state.id ? "Guardar" : "Crear"}
        okButtonProps={{
          disabled: this.validateSave() || !validateEmail(this.state.email),
          loading: this.state.loadingButtonSave,
        }}
        onCancel={() => {
          this.setState({
            id: "",
            first_name: "",
            last_name: "",
            second_last_name: "",
            id_gender: undefined,
            email: "",
            id_role: undefined,
          })
          this.props.setStateFrom("modalCreateUser", false)
          this.props.setStateFrom("userSelected", {})
          resetFields()
        }}
        onOk={() => {
          validateFieldsAndScroll((err, values) => {
            if (!err) {
              if (this.state.id) {
                buttonAction_btns("Editar administrador - Guardar")
                this.sendUpdateServer()
              } else {
                buttonAction_btns("Crear usuario - Crear")
                this.sendCreateServer()
              }
            }
          })
        }}
        className="container-modal-createuser">
        <Form layout="vertical">
          <FormItem
            label={
              <span>
                Selecciona el <span>tipo de usuario</span> que deseas crear:
              </span>
            }
            className="container-modal-createuser__selectadmin">
            {getFieldDecorator("id_role", {
              initialValue: this.state.id_role,
              rules: [
                { required: true, message: formLabelMessage("es", "required") },
              ],
            })(
              <Select
                placeholder="Seleccionar"
                style={{ width: 300 }}
                onChange={(e) => this.setStateFrom("id_role", e)}
                disabled={
                  this.props.disabledRol
                    ? true
                    : this.state.id == LOCAL_USER_ID()
                }>
                <Option value={1}>Superadministrador</Option>
                <Option value={2}>Administrador</Option>
              </Select>
            )}
          </FormItem>

          <label style={{ padding: "0 0 8px", display: "block" }}>
            Nombre y apellido
          </label>
          <Input.Group compact>
            <Form.Item style={{ width: "33.3%" }}>
              {getFieldDecorator("first_name", {
                initialValue: this.state.first_name,
                rules: [
                  {
                    required: true,
                    message: formLabelMessage("es", "required"),
                  },
                ],
              })(
                <Input
                  maxLength={80}
                  placeholder="Nombre"
                  onChange={(e) => {
                    this.setStateFrom("first_name", e.target.value)
                  }}
                />
              )}
            </Form.Item>
            <Form.Item style={{ width: "33.3%" }}>
              {getFieldDecorator("last_name", {
                initialValue: this.state.last_name,
                rules: [
                  {
                    required: true,
                    message: formLabelMessage("es", "required"),
                  },
                ],
              })(
                <Input
                  maxLength={60}
                  placeholder="Apellido Paterno"
                  onChange={(e) => {
                    this.setStateFrom("last_name", e.target.value)
                  }}
                />
              )}
            </Form.Item>
            <Form.Item style={{ width: "33.3%" }}>
              {getFieldDecorator("second_last_name", {
                initialValue: this.state.second_last_name,
              })(
                <Input
                  maxLength={60}
                  placeholder="Apellido Materno"
                  onChange={(e) =>
                    this.setStateFrom("second_last_name", e.target.value)
                  }
                />
              )}
            </Form.Item>
          </Input.Group>

          <FormItem
            label="Género"
            className="container-modal-createuser__selectadmin">
            {getFieldDecorator("id_gender", {
              initialValue:
                typeof this.state.id_gender === "undefined"
                  ? undefined
                  : Number(this.state.id_gender),
              rules: [
                { required: true, message: formLabelMessage("es", "required") },
              ],
            })(
              <Select
                style={{ width: 300 }}
                placeholder="Seleccionar"
                onChange={(e) => this.setStateFrom("id_gender", e)}>
                {map(this.state.genders, ({ name, id_gender }) => {
                  return (
                    <Option key={id_gender} value={id_gender}>
                      {name}
                    </Option>
                  )
                })}
              </Select>
            )}
          </FormItem>

          <FormItem
            className="container-modal-createuser__selectadmin"
            style={{ width: 476 }}
            label={<span>Correo electrónico</span>}>
            {getFieldDecorator("email", {
              initialValue: this.state.email,
              rules: [
                { type: "email", message: formLabel.es.email_valid },
                { required: true, message: formLabelMessage("es", "required") },
              ],
            })(
              <Input
                maxLength={191}
                placeholder="Correo electrónico"
                disabled={this.props.userSelected.is_employee}
                style={{ width: 476 }}
                onChange={(e) => {
                  this.setStateFrom("email", e.target.value)
                }}
              />
            )}
          </FormItem>
        </Form>
      </Modal>
    )
  }
}

export default Form.create({ name: "modal_create_user" })(ModalCreateUser)
